







































































































































































































import XButton from '@/components/atoms/Button/XButton.vue'
import XInput from '@/components/atoms/Input/XInput.vue'
import XForm from '@/components/atoms/Form/XForm.vue'
import XFormLabel from '@/components/atoms/FormLabel/XFormLabel.vue'
import XZipInput from '@/components/atoms/Input/XZipInput.vue'
import XTel from '@/components/atoms/Input/XTel.vue'
import { AddressResponse } from '@/mixin/zipcodeMixin'
import PrefPicker from '@/components/molecules/PrefPicker/PrefPicker.vue'
import BaseStep from './BaseStep.vue'

export default BaseStep.extend({
  name: 'StepOne',
  components: {
    XButton,
    XInput,
    XForm,
    XFormLabel,
    XZipInput,
    XTel,
    PrefPicker,
  },
  methods: {
    setAddress(address: AddressResponse) {
      this.input.prefId = address.prefId
      this.input.address1 = address.locality + address.street
    },
    onSubmitStep() {
      this.onNext('step2')
    },
  },
})
